import React from "react";
import { Link } from "react-router-dom";


const RemovalKit = () => {


    return (
        <div>
            <div class="p-banner">
                Removal Kits
            </div>

            <div class="product-box-inner">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="boxes">

                                <div class="row d-flex justify-content-center">
                                    <div class="col-md-3">
                                        <Link to="/RemovalKitA" style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <div class="product-listing-inner">
                                                <div class="p-inner">
                                                    <img src="/images/Removal-Kit-A.png" alt="image" />
                                                </div>
                                                <div class="detail">
                                                    <h3>Removal Kit A</h3>

                                                    <p>Size:458x305x304mm</p>

                                                    <div class="prices">
                                                        <h5>£239</h5>
                                                    </div>

                                                    {/* <Link href="/add-to-cart">
                                  <button class="loginBtn">Add to Cart</button>
                                </Link> */}
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div class="col-md-3">
                                        <Link to="/RemovalKitB" style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <div class="product-listing-inner">
                                                <div class="p-inner">
                                                    <img
                                                        src="/images/Removal-Kit-B.png" alt="image" />
                                                </div>
                                                <div class="detail">
                                                    <h3>Removal Kit B</h3>

                                                    <p>Size:458x305x304mm</p>

                                                    <div class="prices">
                                                        <h5>£343</h5>
                                                    </div>

                                                    {/* <Link href="/add-to-cart">
                                  <button class="loginBtn">Add to Cart</button>
                                </Link> */}
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div class="col-md-3">
                                        <Link to="/RemovalKitC" style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <div class="product-listing-inner">
                                                <div class="p-inner">
                                                    <img
                                                        src="/images/Removal-Kit-C.png" alt="image" />
                                                </div>
                                                <div class="detail">
                                                    <h3>Removal Kit C</h3>

                                                    <p>Size:458x305x304mm</p>

                                                    <div class="prices">
                                                        <h5>£537</h5>
                                                    </div>

                                                    {/* <Link href="/add-to-cart">
                                  <button class="loginBtn">Add to Cart</button>
                                </Link> */}
                                                </div>
                                            </div>
                                        </Link>
                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default RemovalKit;
